import reducers from "./combineReducer";
import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
const finalCreateStore = compose(applyMiddleware.apply(this, [thunk]))(
  createStore
);
let Store = finalCreateStore(reducers);
Store.subscribe(() => {
  // console.log('正在监听state变化:', Store.getState());
});

export default Store;
export const dispatch = func => {
  Store.dispatch(func);
};



// WEBPACK FOOTER //
// ./src/redux/index.js